import FocusableNodeType from '../../../Tree/Constants/FocusableNodeType';

import createContainer from './createContainer';

/**
 * A focusable-wrapped instance of the `Container` component, with a type and associated behaviour
 * of `HORIZONTAL_LIST`.
 */

export default createContainer(FocusableNodeType.HORIZONTAL_LIST);
